import React, { useState, useEffect } from "react";
import { Dialog } from 'primereact/dialog';
import useTranslations from "i18n/useTranslations";

function ModalAlertConfrim({ 
  open = false,
  title = '',
  subTitle = '',
  branch = '',
  content = `มีบางอย่างผิดพลาด`,
  mode = "blue",
  onClose = () => console.log('onClose'),
  onYes = () => console.log('onYes'),
  onNo = () => console.log('onNo'),
  disbutton = false
}) {
  const { t } = useTranslations();
  let labelCancel = 'ยกเลิก'
  let colorMode = `blue`
  if (mode === "red") {
    colorMode = mode
    labelCancel = 'ไม่ต้องการยกเลิก'
  }
  return (
    <Dialog visible={open} style={{ width: '342px' }} onHide={() => onClose()} draggable={false} resizable={false} closable={false}>
      <div class={`bModal bCard ${colorMode}`} id="ModalAlertConfrim">
        <div className="bInner" style={{ width: "100%"}}>
          <div className="bDetails">
            {/* <!-- <i className="icoAlert"></i> --> */}
            { title ? <h3 dangerouslySetInnerHTML={{ __html: title }}></h3> : <></> }
            { branch ? <h4 dangerouslySetInnerHTML={{ __html: branch }}></h4> : <></> }
            { subTitle ? <p dangerouslySetInnerHTML={{ __html: subTitle }}></p> : <></> }
            { content ? <p dangerouslySetInnerHTML={{ __html: content }}></p> : <></> }
          </div>
          <div className="bBtn">
            <button onClick={() => onYes()} className="btn" disabled = {disbutton}>{t.bottom.confirm}</button>
            <button onClick={() => onNo()} className="btn outline">{t.bottom.cancel}</button>
          </div>
        </div>
      </div>
    </Dialog>
  )
}

export default ModalAlertConfrim;
